export const baseUrl = "https://api.themoviedb.org/3";

export const API_KEY="cfcbfcba7f1a6ec89eae8940ddf88f5a";

export const imageUrl='https://image.tmdb.org/t/p/original/';